// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1msmF","comment":"styles_comment__3CitA"};